export default "__VITE_ASSET__361d6a53__"